"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListItemContext = exports.ListItemProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ListWrapperContext = (0, react_1.createContext)(null);
const ListItemProvider = ({ children, callback }) => {
    const [callbackResponse, setCallbackResponse] = (0, react_1.useState)({});
    return ((0, jsx_runtime_1.jsx)(ListWrapperContext.Provider, { value: { callbackResponse, callback, setCallbackResponse }, children: children }));
};
exports.ListItemProvider = ListItemProvider;
const useListItemContext = () => {
    return (0, react_1.useContext)(ListWrapperContext);
};
exports.useListItemContext = useListItemContext;
//# sourceMappingURL=index.js.map